import Limiter from "../limiter";
import { dispatcher, DispatcherEvents } from "../dispatcher";
import { getServerDate } from "../storage/date";


/**
 * Handles background switch events
*/

export default class NativeBackgroundListener {
    /**
     * Limiter used to determine how many background switch logs are allowed to be created in a given time frame
     */
    private readonly backgroundSwitchEventLimiter: Limiter<null>;

    /**
     * 24 hours in milliseconds
     */
    private readonly oneDay = 86400000;

    /**
     * The error log that is created upon Foreground/Background log limit being reached
     */
    private readonly errorLogger: any;

    private readonly eventKey = "backgroundSwitchEvent";

    private localStorageTimeout: number | undefined;

    /**
     * Determine when last excessive background event error log was created, only one should be generated per day
     */
    private timeSinceLastErrorLog: Date;

    constructor (time: number, size: number, loggerFunction: any) {
        this.timeSinceLastErrorLog = getServerDate();
        this.backgroundSwitchEventLimiter = new Limiter({
            clearingInterval: time,
            sizeLimit: size
        });
        let currentTime: Date = getServerDate();
        this.timeSinceLastErrorLog.setDate(currentTime.getDate() - 1);
        this.errorLogger = loggerFunction;
    }

    /**
     * Handles event when user puts app back into foreground
     */
    foregroundEvent () {
       this.createBackgroundSwitchEvent(true);
    }

    /**
     * Handles event when user puts app into background
     */
    backgroundEvent () {
        this.createBackgroundSwitchEvent(false);
    }

    /**
     * Handles event when background switch event fails to occur
     */
    failureEvent (code: any) {
        dispatcher.trigger(DispatcherEvents.StatusBackground, { code });
    }

    /**
     * Fire background switch event if within allotted limit in given time frame
     * Otherwise generate error log
     * Error log should only be generated once per day to avoid excessive data usage
     */
    createBackgroundSwitchEvent(isTrue: boolean) {
        this.waitForLocalStorage(() => this.triggerBackgroundSwitchEvent(isTrue));
    }

    destroy() {
        if (this.localStorageTimeout) {
            clearTimeout(this.localStorageTimeout);
            this.localStorageTimeout = undefined;
        }
    }

    private waitForLocalStorage(successCallback) {
        let sleep = function(timeout) {
            this.localStorageTimeout = setTimeout(function() {
                if (localStorage || timeout >= 10000) {
                    successCallback();
                } else {
                    sleep(timeout * 10);
                }
            }, timeout);
        };

        localStorage ? successCallback() : sleep(10);
    }

    private triggerBackgroundSwitchEvent(isBackground: boolean) {
        let currentTime = getServerDate();
        this.backgroundSwitchEventLimiter.add(this.eventKey);

        if (!this.backgroundSwitchEventLimiter.isOverflowed(this.eventKey)) {
            dispatcher.trigger(DispatcherEvents.StatusBackground, { isBackground });
        } else if (currentTime.getTime() - this.timeSinceLastErrorLog.getTime() >= this.oneDay) {
            this.timeSinceLastErrorLog = getServerDate();
            this.errorLogger();
        }
    }
}